module.exports = __webpack_public_path__ + "static/img/patent_2.f429a22b.png";